import request from '@/utils/request'


export function login(data) {
  return request({
    url: 'wechat/login/url',
    method: 'post',
    data
  })
}
export function getInfo(data) {
  return request({
    url: 'wechat/get/info',
    method: 'post',
    data
  })
}
export function getRedbagInfoCode(data) {
  return request({
    url: 'wechat/get/redbag/info',
    method: 'post',
    data
  })
}
export function userLogin(data) {
  return request({
    url: 'wechat/login/login',
    method: 'post',
    data
  })
}